/**
 * This module is intended to be used as a submodule.
 * Used in:
 *  - alert
 *  - simulationMessage
 */

import type { Store, StateTree } from "pinia";

export const popupStoreData = defineStoreData({
  state: () => ({
    promise: null as null | Promise<unknown>,
    resolve: null as null | ((reason?: unknown) => void),
    reject: null as null | ((value: unknown) => void)
  }),
  actions: {
    open() {
      console.log("open popup");
      const promise = new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
      this.promise = promise;
      return promise;
    },
    close(data: unknown = true) {
      if (this.resolve) {
        this.resolve(data);
      }

      this.$reset();
    }
  }
});

function defineStoreData<D, S extends StateTree, A>(
  data: D & {
    state?: () => S;
    actions?: A & ThisType<A & Store<string, S, object, A>>;
  }
): D {
  return data;
}
